import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import config from '../../config';
import { Heart, Gear, LinkExternal, Logout, Edit } from '../icons';
import profileIcons from '../icons/profileIcons';

const AccountMenu = props => {
  const {
    isAdmin,
    isStaff,
    profile,
    closeBurgerMenu,
    handleOpenProfileEditorModal,
    onChangeProfileClick,
    handleLogout
  } = props;

  return (
    <div className="header__account-menu">
      <div className="header-dropdown__account-greeting">
        {profile && profileIcons[profile.icon] ? (
          <img
            src={profileIcons[profile.icon]}
            width="72"
            height="72"
            className="header-dropdown__account-greeting-icon"
            alt=""
          />
        ) : (
          <Heart
            width="7.2rem"
            height="7.2rem"
            className="header-dropdown__account-greeting-icon"
          />
        )}
        <button
          className="header-dropdown__account-edit-button"
          onClick={() => {
            closeBurgerMenu('accountOpen');
            handleOpenProfileEditorModal(profile.id);
          }}
        >
          <Edit
            width="1.6rem"
            height="1.6rem"
            className="header-dropdown__account-edit-icon"
            viewBox="0 0 32 32"
          />
        </button>
        <div className="header-dropdown__account-greeting-content">
          {profile ? <h3>{profile.firstName}</h3> : null}
          <NavLink
            onClick={() => {
              onChangeProfileClick();
              closeBurgerMenu('accountOpen');
            }}
            className="header-dropdown__account-greeting-content-link"
            to="#"
          >
            Change Profile
          </NavLink>
        </div>
      </div>
      <NavLink
        onClick={() => closeBurgerMenu('accountOpen')}
        className="full-width-link header-menu-dropdown__link"
        to="/options"
        activeClassName="--active"
      >
        <div className="header-menu-dropdown__link-contents header-menu-dropdown__link-contents--settings">
          <Gear width="24" height="24" viewBox="0 0 32 32" />
          <span>Settings</span>
        </div>
      </NavLink>
      {(isAdmin || isStaff) && (
        <button
          onClick={() => {
            window.open(config.adminURL, '_blank');
            closeBurgerMenu('accountOpen');
          }}
          className="full-width-link header-menu-dropdown__link"
          to="#"
        >
          <div className="header-menu-dropdown__link-contents header-menu-dropdown__link-contents--admin-portal">
            <LinkExternal
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="white"
            />
            <span>Admin Portal</span>
          </div>
        </button>
      )}
      <NavLink
        onClick={() => {
          handleLogout();
        }}
        className="full-width-link header-menu-dropdown__link"
        to="/"
      >
        <div className="header-menu-dropdown__link-contents">
          <Logout width="24" height="24" viewBox="2 0 32 32" fill="white" />
          <span>Log Out</span>
        </div>
      </NavLink>
    </div>
  );
};

AccountMenu.propTypes = {
  isAdmin: PropTypes.bool,
  isStaff: PropTypes.bool,
  profile: PropTypes.shape({
    icon: PropTypes.string,
    id: PropTypes.string,
    firstName: PropTypes.string
  }),
  closeBurgerMenu: PropTypes.func.isRequired,
  handleOpenProfileEditorModal: PropTypes.func.isRequired,
  onChangeProfileClick: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired
};

AccountMenu.defaultProps = {
  isAdmin: false,
  isStaff: false,
  profile: null
};

export default AccountMenu;



// WEBPACK FOOTER //
// ./src/components/Header/AccountMenu.js